// removed by extract-text-webpack-plugin
module.exports = {"confirmButton":"_1dN-N","buttons":"_3dWzB","button":"_233b0 _1dN-N","cancelButton":"_2Y4CS _1dN-N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ConfirmButtons.css
// module id = 798
// module chunks = 0